<div class="rw-popup">
  <div class="arrow"></div>
  <div class="popup-container">
    <ng-content></ng-content>
  </div>
</div>